import { render } from "./SystemLogs.vue?vue&type=template&id=521c4f6f&scoped=true"
import script from "./SystemLogs.vue?vue&type=script&lang=js"
export * from "./SystemLogs.vue?vue&type=script&lang=js"

import "./SystemLogs.vue?vue&type=style&index=0&id=521c4f6f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521c4f6f"],['__file',"src/components/systemLogs/SystemLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "521c4f6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('521c4f6f', __exports__)) {
    console.log('reload')
    api.reload('521c4f6f', __exports__)
  }
  
  module.hot.accept("./SystemLogs.vue?vue&type=template&id=521c4f6f&scoped=true", () => {
    console.log('re-render')
    api.rerender('521c4f6f', render)
  })

}


export default __exports__